import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "Menu";
import { NotificationContainer } from "react-notifications";
import SubMenu from "../SubMenu/SubMenu";
import { HORIZONTAL } from "Config";
import { selectCurrentNavPage, selectLoggedAs } from "Selectors";
import Footer from "./Footer";
import { inIframe } from "Utils";
export class Layout extends Component {
  componentDidMount() {
    $(document).foundation();
  }

  render() {
    const { subMenuDirection, loggedAs, withoutMenu } = this.props;
    return (
      <div className="off-canvas-wrapper">
        <div className="off-canvas-content">
          <Menu />
          <NotificationContainer />
          <div
            className={`flex-container flex-child-auto ${
              subMenuDirection === HORIZONTAL
                ? "flex-dir-column"
                : "flex-dir-row"
            }`}
          >
            {!inIframe && <SubMenu loggedAs={loggedAs} />}
            <div className="flex-child-auto flex-container flex-dir-column">
              {this.props.children}
              {/*<Footer />*/}
              {loggedAs === "GUEST" ? <Footer /> : null}
            </div>
          </div>
        </div>
        <div className="mask hide" />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  subMenuDirection: state.params.subMenuDirection,
  currentNavPage: selectCurrentNavPage(state),
  withoutMenu: state.auth,
  loggedAs: selectLoggedAs(state)
});

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js